/** Готовит SVG для использования в `background-image: url(...)`. */
export function svgMarkupToDataUrl(svgMarkup: string): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgMarkup)}`;
}
